let FilterByTiers = {
    FILTER_BY_TIERS_SET_UNUSED_TIER_NUMBER: 'FILTER_BY_TIERS_SET_UNUSED_TIER_NUMBER',
    SET_PLAYER_TIERS_FILTER: 'SET_PLAYER_TIERS_FILTER',
};

export default FilterByTiers;
